import React from 'react';
import DiagramUtils from '../../../designer/utils/DiagramUtils';
import DiagramUI from "../../../designer/diagrams/DiagramUI";
import Model from "./PageModel";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    render() {

        const style = this.props.model.toStyle();

        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={style}  >

            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "纸张",
    scope: "plot",
    uiGetter: (model) => <UI model={model} />
});